/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CreateStoreDto,
  DataEnvelopeOfObject,
  DataEnvelopeOfStoreDto,
  DataPaginationEnvelopeOfStoreDto,
  ErrorEnvelope,
  ListStoresParams,
  UpdateStoreDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Lista as lojas do tenant atual
 */
export const listStores = (
  params?: ListStoresParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfStoreDto>(
    { url: `/v1/stores`, method: 'GET', params, signal },
    options,
  )
}

export const getListStoresQueryKey = (params?: ListStoresParams) => {
  return [`/v1/stores`, ...(params ? [params] : [])] as const
}

export const getListStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorEnvelope,
>(
  params?: ListStoresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStores>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListStoresQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStores>>> = ({ signal }) =>
    listStores(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listStores>>>
export type ListStoresQueryError = ErrorEnvelope

export function useListStores<
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorEnvelope,
>(
  params: undefined | ListStoresParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStores>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStores>>,
          TError,
          Awaited<ReturnType<typeof listStores>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStores<
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorEnvelope,
>(
  params?: ListStoresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStores>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStores>>,
          TError,
          Awaited<ReturnType<typeof listStores>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStores<
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorEnvelope,
>(
  params?: ListStoresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStores>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as lojas do tenant atual
 */

export function useListStores<
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorEnvelope,
>(
  params?: ListStoresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStores>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListStoresQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Cria uma loja (Admin/Manager)
 */
export const createStore = (
  createStoreDto: CreateStoreDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfStoreDto>(
    {
      url: `/v1/stores`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createStoreDto,
      signal,
    },
    options,
  )
}

export const getCreateStoreMutationKey = () => ['createStore'] as const

export const getCreateStoreMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStore>>,
    TError,
    CreateStoreMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStore>>,
  TError,
  CreateStoreMutationVariables,
  TContext
> => {
  const mutationKey = getCreateStoreMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStore>>,
    CreateStoreMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createStore(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof createStore>>>
export type CreateStoreMutationBody = CreateStoreDto
export type CreateStoreMutationError = ErrorEnvelope
export type CreateStoreMutationVariables = { data: CreateStoreDto }

/**
 * @summary Cria uma loja (Admin/Manager)
 */
export const useCreateStore = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStore>>,
      TError,
      CreateStoreMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createStore>>,
  TError,
  CreateStoreMutationVariables,
  TContext
> => {
  return useMutation(getCreateStoreMutationOptions(options), queryClient)
}
/**
 * @summary Obtém uma loja do tenant atual
 */
export const getStore = (
  uuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfStoreDto>(
    { url: `/v1/stores/${uuid}`, method: 'GET', signal },
    options,
  )
}

export const getGetStoreQueryKey = (uuid: string) => {
  return [`/v1/stores/${uuid}`] as const
}

export const getGetStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getStore>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStoreQueryKey(uuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStore>>> = ({ signal }) =>
    getStore(uuid, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: uuid !== null && uuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetStoreQueryResult = NonNullable<Awaited<ReturnType<typeof getStore>>>
export type GetStoreQueryError = ErrorEnvelope

export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = ErrorEnvelope>(
  uuid: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStore>>,
          TError,
          Awaited<ReturnType<typeof getStore>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = ErrorEnvelope>(
  uuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStore>>,
          TError,
          Awaited<ReturnType<typeof getStore>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = ErrorEnvelope>(
  uuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém uma loja do tenant atual
 */

export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = ErrorEnvelope>(
  uuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStoreQueryOptions(uuid, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza parcialmente uma loja (Admin/Manager)
 */
export const updateStore = (
  uuid: string,
  updateStoreDto: UpdateStoreDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfStoreDto>(
    {
      url: `/v1/stores/${uuid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateStoreDto,
      signal,
    },
    options,
  )
}

export const getUpdateStoreMutationKey = () => ['updateStore'] as const

export const getUpdateStoreMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStore>>,
    TError,
    UpdateStoreMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  UpdateStoreMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateStoreMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStore>>,
    UpdateStoreMutationVariables
  > = (props) => {
    const { uuid, data } = props ?? {}

    return updateStore(uuid, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof updateStore>>>
export type UpdateStoreMutationBody = UpdateStoreDto
export type UpdateStoreMutationError = ErrorEnvelope
export type UpdateStoreMutationVariables = { uuid: string; data: UpdateStoreDto }

/**
 * @summary Atualiza parcialmente uma loja (Admin/Manager)
 */
export const useUpdateStore = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStore>>,
      TError,
      UpdateStoreMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  UpdateStoreMutationVariables,
  TContext
> => {
  return useMutation(getUpdateStoreMutationOptions(options), queryClient)
}
/**
 * @summary Remove uma loja sem vínculos (Admin)
 */
export const deleteStore = (
  uuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/stores/${uuid}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteStoreMutationKey = () => ['deleteStore'] as const

export const getDeleteStoreMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStore>>,
    TError,
    DeleteStoreMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStore>>,
  TError,
  DeleteStoreMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteStoreMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStore>>,
    DeleteStoreMutationVariables
  > = (props) => {
    const { uuid } = props ?? {}

    return deleteStore(uuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteStoreMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStore>>>

export type DeleteStoreMutationError = ErrorEnvelope
export type DeleteStoreMutationVariables = { uuid: string }

/**
 * @summary Remove uma loja sem vínculos (Admin)
 */
export const useDeleteStore = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStore>>,
      TError,
      DeleteStoreMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStore>>,
  TError,
  DeleteStoreMutationVariables,
  TContext
> => {
  return useMutation(getDeleteStoreMutationOptions(options), queryClient)
}
/**
 * @summary Ativa ou desativa uma loja (Admin/Manager)
 */
export const toggleStoreActive = (
  uuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfStoreDto>(
    { url: `/v1/stores/${uuid}/toggle-active`, method: 'PATCH', signal },
    options,
  )
}

export const getToggleStoreActiveMutationKey = () => ['toggleStoreActive'] as const

export const getToggleStoreActiveMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleStoreActive>>,
    TError,
    ToggleStoreActiveMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleStoreActive>>,
  TError,
  ToggleStoreActiveMutationVariables,
  TContext
> => {
  const mutationKey = getToggleStoreActiveMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleStoreActive>>,
    ToggleStoreActiveMutationVariables
  > = (props) => {
    const { uuid } = props ?? {}

    return toggleStoreActive(uuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ToggleStoreActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleStoreActive>>
>

export type ToggleStoreActiveMutationError = ErrorEnvelope
export type ToggleStoreActiveMutationVariables = { uuid: string }

/**
 * @summary Ativa ou desativa uma loja (Admin/Manager)
 */
export const useToggleStoreActive = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleStoreActive>>,
      TError,
      ToggleStoreActiveMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleStoreActive>>,
  TError,
  ToggleStoreActiveMutationVariables,
  TContext
> => {
  return useMutation(getToggleStoreActiveMutationOptions(options), queryClient)
}
